<template>
<b-skeleton-wrapper :loading="loading">
	<template v-slot:loading>
		<b-card
		class="card-skeleton m-b-15">
			<b-skeleton type="button" width="70%" class="m-b-15"></b-skeleton>
			<b-skeleton type="button" width="40%" class="m-b-15"></b-skeleton>
			<b-skeleton type="button" width="100%"></b-skeleton>
		</b-card>
	</template>
	<div
	class="m-t-20 m-b-20 article-data"
	v-if="article_to_show">
		<name-heart></name-heart>

		<price></price>
		<vinoteca></vinoteca>
		
		<payment-methods-info></payment-methods-info>

		<condition></condition>	

		<!-- <notes></notes> -->

		<add-to-cart
		:article="article_to_show"></add-to-cart>

		<div class="article-data__actions">
			<compartir
			:article="article_to_show"></compartir>

			<whatsapp-link></whatsapp-link>
		</div>
	</div>
</b-skeleton-wrapper>
</template>
<script>
import NameHeart from '@/components/article/components/data/NameHeart'
import PaymentMethodsInfo from '@/components/article/components/data/PaymentMethodsInfo'
import Price from '@/components/article/components/data/Price'
import Condition from '@/components/article/components/data/Condition'
// import Notes from '@/components/article/components/data/Notes'
import AddToCart from '@/components/article/components/data/add-to-cart/Index'
import Compartir from '@/components/article/components/data/Compartir'
import WhatsappLink from '@/components/article/components/data/WhatsappLink'

import BtnLoader from '@/components/common/BtnLoader'
export default {
	name: 'ArticleData',
	components: {
		NameHeart,
		Vinoteca: () => import('@/components/article/components/data/Vinoteca'),
		PaymentMethodsInfo,
		Price,
		Condition,
		// Notes,
		AddToCart,
		Compartir,
		WhatsappLink,

		BtnLoader,
	},
	computed: {
		loading() {
			return this.$store.state.articles.loading_article_to_show
		},
	},
}
</script>
<style lang="sass">
.article-data
	background: #FFF
	border-radius: 10px
	border: 2px solid #DDDDDD
	padding: 25px
	/* Anula text-align: center de #app en la tarjeta del producto. */
	text-align: left

/* Acciones secundarias del artículo (compartir y WhatsApp). */
.article-data__actions
	margin-top: 0.75rem
	display: flex
	flex-direction: column
	align-items: stretch
	gap: 0.5rem
	width: 100%
</style>

